import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { adminDeleteVideo, fetchUserVideos } from '../lib/superadminUsersApi';

const UserVideos: React.FC = () => {
  const params = useParams();
  const idNum = Number(params.id || '');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>({ total: 0, rows: [] });
  const [search, setSearch] = useState('');
  const [pending, setPending] = useState('');

  useEffect(() => { const t = setTimeout(() => setSearch(pending), 300); return () => clearTimeout(t); }, [pending]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await fetchUserVideos(idNum, { search, limit: 50, order: 'desc', sort: 'createdAt' });
      setData(res);
    } catch (e: any) {
      setError(e?.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNum, search]);

  const onDelete = async (id: number) => { if (!window.confirm('Delete video?')) return; await adminDeleteVideo(id); await load(); };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded shadow p-4">
        <div className="flex gap-3">
          <input className="border rounded px-3 py-2 w-full" placeholder="Search" value={pending} onChange={(e) => setPending(e.target.value)} />
        </div>
      </div>
      {loading ? <div>Loading…</div> : error ? <div className="text-red-600">{error}</div> : (
        <div className="overflow-x-auto bg-white rounded shadow">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500">
                <th className="py-2 pr-4">Title</th>
                <th className="py-2 pr-4">Comments</th>
                <th className="py-2 pr-4">Uploaded</th>
                <th className="py-2 pr-4">Shared</th>
                <th className="py-2 pr-4">Workspace</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((v: any) => (
                <tr key={v.id} className="border-t">
                  <td className="py-2 pr-4 text-blue-600"><a href={v.videoUrl} target="_blank" rel="noreferrer">{v.title}</a></td>
                  <td className="py-2 pr-4">{v.commentCount}</td>
                  <td className="py-2 pr-4">{new Date(v.createdAt).toLocaleString()}</td>
                  <td className="py-2 pr-4">{v.sharedWithCount}</td>
                  <td className="py-2 pr-4">{v.workspace}</td>
                  <td className="py-2 pr-4"><button className="text-red-600" onClick={() => onDelete(v.id)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserVideos;


